module.exports = __webpack_public_path__ + "static/media/OwnaHouse.da4de3df.png";